import {
    Unstable_Grid2 as Grid, Card, CardHeader, CardContent, TextField, Box, Typography, Chip, Button, ToggleButtonGroup, ToggleButton,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent
} from '@mui/material';
import { DataOutput, DropdownModel, EditorType, NLCInfo, TableInfo } from '../../../data/interfaces/sharedmodels';
import { useAppDispatch, useAppSelector } from '../../../stores/hooks';
import { updateselectedNlcs, updateVersion } from '../../../stores/magneticslice';
import NLCList from '../../../shared/nlclist';
import Tables from '../../../shared/datamanagementcomponents/datatables';
import { useEffect, useState, useCallback, createContext, useContext } from 'react';
import magneticService from '../../../data/api/magnetic.service';
import EditableDataList from '../../../shared/datamanagementcomponents/editabledatatable';
import { cubictheme } from '../../../../assets/cubictheme';
import EditableAcceptanceDataList from '../../../shared/datamanagementcomponents/editableacceptancelist';
import EditableForm from '../../../shared/datamanagementcomponents/editableform';
import BreakOfJourney from '../../../shared/datamanagementcomponents/breakofjourney';
import Languages from '../../../shared/datamanagementcomponents/languages';
import TimeRestrictions from '../../../shared/datamanagementcomponents/timerestrictions';


// interface IsEdited {
//     isEdited: boolean,
//     setIsEdited: (newValue: boolean) => void

// }
// export const IsEditedContext = createContext<IsEdited>({
//     isEdited: false,
//     setIsEdited: (newValue: boolean) => { }
// });


export default function MagneticTables() {
    const dispatch = useAppDispatch();
    const [tables, setTables] = useState<TableInfo[]>([]);
    const [versions, setVersions] = useState<DropdownModel[]>([]);
    const [data, setData] = useState<any>({ Fields: [], Rows: [], VersionDetails: null, FieldGroups: [], FieldLookups: [], CanAddRows: false });
    const [widthArray, setWidthArray] = useState([3, 3, 6]);
    const selectedTable = useAppSelector((state) => state.magneticReducer.selectedDataTable);
    const datatbleexpanded = useAppSelector((state) => state.magneticReducer.datatableExpanded);
    const selectedNlcs = useAppSelector((state) => state.magneticReducer.selectedNlcs);
    const selectedVersion = useAppSelector((state) => state.magneticReducer.selectedVersion);
    const versionChangedCounter = useAppSelector((state) => state.magneticReducer.versionChangedCounter);
    const filterFields = useAppSelector((state) => state.magneticReducer.filterAttributes);
    const editorType = useAppSelector((state) => state.magneticReducer.editorType);
    //const [isEdited, setIsEdited] = useState(false);
    
    useEffect(() => {
        
            magneticService.getdatatables().then((response) => {
                setTables(response.data);
            });
    
    }, []);
    useEffect(() => {
     
        if (selectedTable) {
           
           
            if (selectedTable.IsGlobal) {
                if (selectedNlcs.length > 0)
                    dispatch(updateselectedNlcs([]));
                loadVersions(selectedTable.Id, null);
            }
            else if (selectedNlcs.length > 0) {
                loadVersions(selectedTable.Id, selectedNlcs[0].Id);
            }
            else {
                setVersions([]);
            }
        
        }
    
    }, [selectedTable, filterFields]);



    useEffect(() => {
        if (selectedTable) {
            if (!selectedTable.IsGlobal && selectedNlcs.length > 0) {
                loadVersions(selectedTable.Id, selectedNlcs[0].Id);
            }
            else if (!selectedTable.IsGlobal) {
                setVersions([]);
            }

        }
    }, [selectedNlcs]);

    const loadVersions = (tableId: number, nlcId: number | null) => {
        magneticService.gettableVersions(tableId, nlcId).then((response) => {
            setVersions(response.data);
        });
    }

    useEffect(() => {
        
        if (selectedTable && selectedVersion) {

            magneticService.getdata(selectedTable?.Id,
                (!selectedTable.IsGlobal && selectedNlcs.length > 0) ? selectedNlcs[0].Id : undefined, selectedVersion, filterFields,
                selectedTable.EditorType == EditorType.TableOrForm ? editorType : selectedTable.EditorType).then((response) => {
                    if (response && response.data) {
                        setData(response.data);
                    }
                    else {
                        setData({ Fields: [], Rows: [], VersionDetails: null, FieldGroups: [], FieldLookups: [], TypeLookups: [], CanAddRows: false });
                    }

                })

        }
        else if (selectedTable?.EditorType == EditorType.BreakOfJourney) {
            setData({ BojItems: [], OriginGroups: [], DestinationGroups: [], BojGroups: [], Nlcs: [] })
        }
        else if (selectedTable?.EditorType == EditorType.Language) {
            setData({ DefaultTexts: [], TopLineItem: { LineTexts: [] }, BottomLineItem: { LineTexts: [] }, TypeLookUps: [] })
        }
        else if (selectedTable?.EditorType == EditorType.TimeRestrcitions) {
            setData({ TravelSets: [], RestrictionDays: [], RestrictionId: null, TimeRestrictions: [], Fields: [], TypeLookUps: [] });

        }
        else if (selectedTable?.EditorType == EditorType.Acceptance) {
            setData({ SelectedItems: [], LookUpItems: [], Fields: [], TypeLookups: [] })
        }
        else {
            setData({ DefaultTexts: [], TopLineItem: { LineTexts: [] }, BottomLineItem: { LineTexts: [] }, TypeLookUps: [] })
        }
   
    }, [versionChangedCounter, editorType]);

    useEffect(() => {
        if (versions && versions.length > 0) {
            dispatch(updateVersion(versions[0].Id));
        }
        else {
            dispatch(updateVersion(null));
        }
    }, [versions])

    useEffect(() => {
        if (datatbleexpanded) {
            setWidthArray([0, 0, 12]);

        }
        else {
            setWidthArray([2.5, 2.5, 7]);
        }
    }, [datatbleexpanded]);

    const handleSave = useCallback(() => {
       
        magneticService.gettableVersions(selectedTable?.Id ?? 0, selectedNlcs.length > 0 ? selectedNlcs[0].Id : null).then((response) => {
            setVersions(response.data);
        });
    
    }, [selectedTable, selectedNlcs]);

   

    return (
      
            <Grid container spacing={widthArray[2] == 12 ? 0 : 1}>
                <Grid xs={widthArray[0]}>
                    <Tables parent='magnetic' tables={tables} />
                </Grid>
                <Grid xs={widthArray[1]}>
                    <NLCList parent='magnetic' disabled={selectedTable == null ? false : selectedTable.IsGlobal} />
                </Grid>
                <Grid xs={widthArray[2]} sx={{ transition: cubictheme.transitions.easing.sharp }}>

                    {selectedTable?.EditorType == EditorType.Table || (selectedTable?.EditorType == EditorType.TableOrForm && editorType == EditorType.Table) ?
                        <EditableDataList parent='magnetic' heading={selectedTable?.Description} data={data} versions={versions} callback={handleSave} /> :
                        selectedTable?.EditorType == EditorType.Acceptance ?
                            <EditableAcceptanceDataList parent='magnetic' heading={selectedTable?.Description} data={data} versions={versions} callback={handleSave} /> :
                            selectedTable?.EditorType == EditorType.Form || (selectedTable?.EditorType == EditorType.TableOrForm && editorType == EditorType.Form) ? <EditableForm parent='magnetic' heading={selectedTable?.Description}
                                versions={versions} callback={handleSave} data={data} /> :
                                selectedTable?.EditorType == EditorType.BreakOfJourney ? <BreakOfJourney parent='magnetic' heading={selectedTable?.Description} data={data} versions={versions} callback={handleSave}></BreakOfJourney> :
                                    selectedTable?.EditorType == EditorType.Language ? <Languages parent='magnetic' heading={selectedTable?.Description} data={data} versions={versions} callback={handleSave} /> :
                                        selectedTable?.EditorType == EditorType.TimeRestrcitions ? <TimeRestrictions parent='magnetic' heading={selectedTable?.Description} data={data} versions={versions} callback={handleSave} /> : <div>Coming Soon</div>
                    }
                </Grid>
            </Grid>

       
    );
}  